export const UPDATE_ORDER_ID = 'shoppingCompleted/UPDATE_ORDER_ID'
export const UPDATE_IS_COMPLETED = 'shoppingCompleted/UPDATE_IS_COMPLETED'
export const UPDATE_IS_LOGGED_IN = 'shoppingCompleted/UPDATE_IS_LOGGED_IN'


